import { customShape } from './grid_customshape';
import { inferPosition } from './grid_data';

function buildXY(x1, y1, x2, y2, height, level) {
  const denum = Math.abs(y2 - y1) + Math.abs(x2 - x1);
  // proportion of dx/dy on the slope
  const dx = Math.abs(x2 - x1) / denum * (x2 - x1 > 0 ? 1 : -1);
  const dy = Math.abs(y2 - y1) / denum * (y2 - y1 > 0 ? 1 : -1);

  // must reach 70 of radius
  const radius_scale = level == "primary" ? 50 : 35;
  // build a cicle radius and contribution to it;
  const hypo = Math.sqrt(dx*dx + dy*dy);
  const dx_radius = radius_scale / hypo * dx;
  const dy_radius = radius_scale / hypo * dy;

  const new_x1 = x1 * height + dx_radius;
  const new_y1 = y1 * height + dy_radius;

  return [new_x1, new_y1];
}

const inferDetails = (node_struct) => {
   if (node_struct.poi_contact) {
    return [node_struct.poi_contact.id, "contact"]
  }
   if (node_struct.poi_entity) {
    return [node_struct.poi_entity.id, "entity"]
  }
}

// need to build a start node, an end node and a link...
const buildLink = (node_struct, height, editable) => {
  const [id, type] = inferDetails(node_struct)

  const {start_coord: [x1, y1], end_coord: [x2, y2]} = node_struct;
  const [new_x1, new_y1] = buildXY(x1, y1, x2, y2, height, node_struct.level);

  const node_start = {
    id: `${type}_start_${id}`,
    type: `${type}_start`,
    loaded: true,
    locked: true,
    x: new_x1,
    y: new_y1,
    draggable: false,
    // x: x1 * height, y: y1 * height,
    // style: {radius: 0}
    style: {
      label: "",
      radius: 0,
    },
  };

  const node_end = {
    id: `${type}_end_${id}`,
    type: `${type}_end`,
    loaded: true,
    locked: true,
    x: x2 * height,
    y: y2 * height,
    // style: {radius: 0}
    style: {
      // label: `${x2*height} ${y2*height}`,
      draggable: editable,
      radius: editable ? 10 : 0,
      label: "",
      cursor: "pointer",
    }
  };

  const link = {
    id: `${type}_${id}_arrow`,
    from: `${type}_start_${id}`,
    to: `${type}_end_${id}`,
    style: {
      // label: `${x1}/${y1} => ${new_x1} (${dx}) ${x2}/${y2} => ${new_y1} (${dy})`,
      label: "",
      radius: 14,
      // fillColor: "rgba(236,46,46,1)",
      fillColor: "yellow",
      toDecoration: "arrow",
      selected: {
	// shadowBlur: 20
      },
      shadowBlur: 5,
      shadowColor: "rgba(0, 0, 0, 0.7)",
      shadowOffsetX: -8,
      shadowOffsetY: 8,
    }
  }

  return [[node_start, node_end], link]
}

const getHoverText = (data) => {
  let text = data.information;
  const max_length = 300;
  if (data.information.length > max_length) {
    text = data.information.slice(0, max_length - 3) + "..."
  }

  return `
  **${data.label} - ${data.role}**

  ${text}
  `;
}


// initial build of node
const buildNode = (node_struct, type, id, image, height, editable) => {
  const {start_coord: [x1, y1], end_coord: [x2, y2]} = node_struct;

  const initial_node = {
    id: `${type}_${id}`,
    old_id: id,
    type: type,
    loaded: true,
    locked: true,
    x: x1 * height,
    y: y1 * height,
    hoverText: getHoverText(node_struct),
    level: node_struct.level,
    style: {
      // label: `${x1*height} ${y1*height}`,
      cursor: "pointer",
      label: "",
      display: "image",
      imageCropping: true,
      image: image,
      radius: node_struct.level == "primary" ? 40 : 25,
      // blur
      shadowBlur: 5,
      shadowColor: "rgba(0, 0, 0, 0.7)",
      shadowOffsetX: -8,
      shadowOffsetY: 8,
      draggable: editable,
      lineColor: node_struct.target ? "red" : null,
      lineWidth: node_struct.target ? 4 : null,
      // selected: { radius: 60 }
    }
  }

  // return list of nodes, and link
  if (x2 && y2) {
    const [nodes, link] = buildLink(node_struct, height, editable);
    return [[initial_node].concat(nodes), link]
  } else {
    return [[initial_node], null]
  }
}


function transformData({ contact_nodes, entity_nodes }, height, isEditable) {
  let _nodes = [];
  let _links = [];

  contact_nodes.forEach(node => {
    const editable = isEditable(node);

    const [nodes, link] = buildNode(node, "contact", node.poi_contact.id, node.poi_contact.img, height, editable);

    // add to global var
    nodes.forEach(n => { _nodes.push(n) });
    if (link) { _links.push(link); }
  })

  entity_nodes.forEach(node => {
    const editable = isEditable(node);

    const [nodes, link] = buildNode(node, "entity", node.poi_entity.id, node.poi_entity.img, height, editable);

    // add to global var
    nodes.forEach(n => { _nodes.push(n) });
    if (link) { _links.push(link); }
  })

  return { nodes: _nodes, links: _links };
}


/*
Two updates:

A. update

On drag end:
a. we need to get the x/y so it's sent to the form (check if first or second point)

b.
- if this is the second point update it
- if this is the main point update its sibling


B. add second point


C. remove second point

We need to know when the event is set
We need to know when the event is set

*/


const buildConverter = (side_size) => {
  return (node) => {
    return [node.x / side_size, node.y / side_size];
  }
}

// ensure data is in bound
const ensurer = (data, height) => {
  data.x = Math.min(Math.max(0, data.x), height);
  data.y = Math.min(Math.max(0, data.y), height);
  return data;
}

const rebuildNode = (id, type, nodes, height) => {
  const original_id = `${type}_${id}`;
  const end_id = `${type}_end_${id}`;

  const ensure = (data) => ensurer(data, height);

  // to build
  const start_id = `${type}_start_${id}`;

  const original_node = nodes.find(node => node.id == original_id)
  const end_node = nodes.find(node => node.id == end_id)

  if (original_node && end_node) {
    const [new_x1, new_y1] = buildXY(
      original_node.x / height, original_node.y / height,
      end_node.x / height, end_node.y / height,
      height,
      original_node.level
    );

    return nodes.map(node => {
      if (node.id == start_id) {
	return  ensure({...node.data, x: new_x1, y: new_y1});
      } else if (node == original_node) {
	return ensure({...node.data, x: original_node.x, y: original_node.y})
      } else if (node == end_node) {
	return ensure({...node.data, x: end_node.x, y: end_node.y})
      } else {
	return node.data;
      }
    });

  } else {
    return null;
  }
}


// return id of a matching node to update
const getNodeToUpdate = (node) => {
  if (!node.data.type) return;

  let old_id = null;
  let type = null;

  if (["contact", "entity"].includes(node.data.type)) {
    old_id = node.data.old_id;
    type = node.data.type;
  } else if (node.data.type.endsWith("end")) {
    const [v_type, _end, v_id] = node.data.id.split("_");
    old_id = v_id;
    type = v_type;
  } else {
    return;
  }

  return [old_id, type];
}


// take all nodes of chart,
// otherwise we will forgot previous changes (if updating start then end node)
function updateNode(chart, node, side_size) {
  // look
  const convert = buildConverter(side_size)


  // ensure we get a proper node that we are allowed to update
  // an origin or and end
  const node_details = getNodeToUpdate(node);

  console.log(node_details);

  if (! node_details) {
    return;
  }

  const [old_id, type] = node_details;
  // problem is we need to update the data itself
  // const nodes = initial_data.nodes;
  const nodes = chart.nodes();

  // trying to rebuild the node w/ the arrow
  const new_node_datas = rebuildNode(
    old_id,
    type,
    nodes,
    side_size
  );

  const ensure = (data) => ensurer(data, side_size);

  if (new_node_datas) {
    chart.replaceData({
      nodes: new_node_datas,
      links: chart.links().map(x => x.data)
    });
  } else {
    // simply replace the update x/y
    chart.replaceData({
      nodes: chart.nodes().map(n => {
	return n.id === node.id ? ensure({...node.data, x: n.x, y: n.y}) : n.data;
      }),
      links: chart.links().map(x => x.data)
    });
  }

  const data = ensure({x: node.x, y: node.y});
  const coord = [data.x / side_size, data.y / side_size];

  // rebuild data by overriding x/y
  const key = ["contact", "entity"].includes(node.data.type) ? "start" : "end";

  return {
    [key + "_coord"]: coord,
    [key + "_position"]: inferPosition(coord)
  };
}

// dynamically add / remove node or links and return the update coord
// warning as data may be 
function chartToggleEndPosition(chart, node_struct, add_or_delete, x_max) {
  let end_coord = null;

  if (add_or_delete) {
    // adding
    end_coord = [0.5, 0.5]; // full center

    // we need to find back the node as chart.nodes() is the source of truth T_T

    const [nodes, link] = buildLink({...node_struct, end_coord}, x_max, true);

    chart.addData({ nodes, links: [link] })

    return {
      end_coord,
      end_position: inferPosition(end_coord)
    }
  } else {
    // build just to get ids
    const [nodes, link] = buildLink({...node_struct, end_coord: [1, 1]}, x_max, true);

    chart.removeData({
      nodes: nodes.map(x => { return {id: x.id}; }),
      links: [{id: link.id}]
    })

    return {
      end_coord: [null, null],
      end_position: null
    }
  }
}

export { transformData, updateNode, chartToggleEndPosition };
